import React from 'react'
import { FrontPage } from 'cvs-core'
import menuLogo from '../../assets/images/Vape-Free-Reverse-Text-Red-X Copy@2x.jpg'
import foregroundImg from '../../assets/images/CVS-CATCH-MS-SPM-LandingPage-vape-lineup.svg'
import backgroundImg from '../../assets/images/CVS-CATCH-MS-SPM-LandingPage-corner-graphic.svg'

// const foregroundImg = 'http://via.placeholder.com/200x150';

const data = {
  title: 'Vaping Risks Revealed',
  subTitle: '',
  intro: (
    <p>
      Some people believe that vaping is safer than smoking cigarettes—do you?
      Let’s learn about the effects of using e-cigarettes on your brain and body
      along with strategies for responding to pressure to vape, so you can make
      safe choices!
    </p>
  ),
  logo: menuLogo,
  foregroundImg,
  backgroundImg,
}

export default {
  title: 'Welcome',
  path: '/',
  content: <FrontPage data={data} />,
}



// WEBPACK FOOTER //
// ./src/data/home/index.js